module.exports = __webpack_public_path__ + "img/MOBILE.587cb219.svg";